import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/hooks/use-auth-compat';
import {
  fetchStudentSettings,
  updateStudentSettings,
  type StudentProfileSettings,
} from '@/services/studentSettingsService';

export function useStudentSettings() {
  const auth = useAuth();
  const token = auth.user?.access_token ?? '';

  return useQuery({
    queryKey: ['studentSettings'],
    queryFn: () => fetchStudentSettings(token),
    enabled: !!token,
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateStudentSettings() {
  const auth = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (patch: Partial<StudentProfileSettings>) => {
      const token = await auth.getToken();
      return updateStudentSettings(token, patch);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['studentSettings'] });
    },
  });
}
